<template>
<div >
  404 not found
</div>
</template>

<script>
export default {
  name: "not_found"
}
</script>

<style scoped>

</style>
